// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountRequestModel {
    static getAttributeTypeMap() {
        return SiteAccountRequestModel.attributeTypeMap;
    }
}
SiteAccountRequestModel.discriminator = undefined;
SiteAccountRequestModel.additionalProperties = false;
SiteAccountRequestModel.attributeTypeMap = [
    {
        "name": "siteAccount",
        "baseName": "siteAccount",
        "type": "SiteDetails"
    },
    {
        "name": "siteAccountContact",
        "baseName": "siteAccountContact",
        "type": "SiteAccountContact"
    },
];
//# sourceMappingURL=siteAccountRequestModel.js.map